import { getShiftByParameters } from "@dexteel/mesf-core";
import { useQuery } from "@tanstack/react-query";

export type DefaultShift = {
	ShiftId: number;
	Shift: string | null;
	Crew: string | null;
};

// The shift running now, independent of the shift navigator (which may be on another shift)
export const useCurrentShift = () =>
	useQuery<DefaultShift | null, Error>({
		queryKey: ["logbookCurrentShift"],
		queryFn: async () => {
			const resp = await getShiftByParameters({
				productionDate: null,
				shiftId: 0,
			});
			if (!resp.ok) throw new Error(resp.message || "Error fetching shift");
			const data = resp.data;
			return data?.CurrentShiftId
				? {
						ShiftId: data.CurrentShiftId,
						Shift: data.CurrentShift ?? null,
						Crew: data.CurrentCrew ?? null,
					}
				: null;
		},
		// a shift lasts hours; refresh often enough to roll over to the next one
		refetchInterval: 5 * 60 * 1000,
	});
